import React, { useEffect, useState } from "react";
import GBTSLogoSvg from "../../../assets/GBTSLogoSvg";
import BuddibleSocket from "../../../lib/BuddibleSocket";
import Utilities from "../../../lib/Utilities";
import { useTranslation } from "react-i18next";

const socket = new BuddibleSocket();
const util = new Utilities();

export default function Partners() {
  const [adList, setAdList] = useState([]);
  const { t } = useTranslation();

  useEffect(() => {
    SELECT_PARTNER_LIST();
  }, []);

  function SELECT_PARTNER_LIST() {
    let msgID = util.makeUUIDv4();
    let socketMsg = {
      file: "/product_hosts/JS_product_hosts_select.php",
      msgID: msgID,
      data: {},
      AD_USE_YN: "Y",
      AD_EXPOSURE_LOCATION: "M",
      sort: [
        {
          field: "AD_CREATE_DATE",
          dir: "desc",
        },
      ],
    };
    socket.sendMessage(socketMsg, msgID, (beforeData, newData) => {
      if (newData) {
        if (newData["ret"]) {
          setAdList(newData["returnData"]);
        }
      }
    });
  }

  return (
    <div className="py-5">
      <div className="container margin_30">
        <div className="row m-0">
          <div className="col-12 text-center mb-5">
            <div className="h4 font-weight-bold mb-2">
              <GBTSLogoSvg /> <br className="d-sm-none" />
              {t("main.partners.title")}
            </div>
            <p className="text-secondary">{t("main.partners.description")}</p>
          </div>

          <div className="col-12 m-0 p-0">
            <div className="row m-0 p-0">
              {adList.map((params, index) => {
                const item = { ...params };
                const imgSrc = item.AD_LOGO.split("?")[1];
                return (
                  <div key={index} className="col-3 m-0 p-1">
                    <div
                      className="tour_container shadow-none"
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        height: 80,
                        marginBottom: "6px",
                      }}
                    >
                      <div className="ad-container cursor_pointer">
                        <div
                          className="w-100 h-100 bg-white rounded border border-light cursor_pointer_shadow"
                          style={{
                            background: `url(${imgSrc}) 50% 50%/contain  no-repeat`,
                          }}
                          onClick={() => {
                            if (item.AD_COMP_HOMEPAGE) {
                              if (!item.AD_COMP_HOMEPAGE.match("http")) {
                                window.open(
                                  `https://${item.AD_COMP_HOMEPAGE}`,
                                  "",
                                  "_blank"
                                );
                              } else {
                                window.open(
                                  `${item.AD_COMP_HOMEPAGE}`,
                                  "",
                                  "_blank"
                                );
                              }
                            }
                          }}
                        />
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
